import React from "react";
import PropTypes from "prop-types";
import axios from "axios";
import Button from "@shared/v2/Button";
import ConfirmationModal from "./ConfirmationModal";
import ConferenceModal from "./ConferenceModal";

class ConferenceCall extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      callConfirmationOpen: false,
      callModalOpen: false,
      startCall: false,
      selectedLeadUuids: [],
      conferenceUuid: null,
      dialerServiceToken: null,
      isLoading: false,
    };
  }

  closeConfirmationModal = () => {
    this.setState({ callConfirmationOpen: false });
  };

  closeCallModal = () => {
    this.setState({
      callModalOpen: false,
      startCall: false,
      conferenceUuid: null,
      dialerServiceToken: null,
    });
  };

  createDialerSession = () => {
    const { selectedLeadUuids } = this.state;
    this.setState({ isLoading: true });
    axios
      .post("/dialer/create_dialer_session", {
        call_source: "Lead Index Brivity Dialer",
        lead_uuids: selectedLeadUuids,
        authenticity_token: ReactOnRails.authenticityToken(),
      })
      .then((resp) => {
        this.setState({
          conferenceUuid: resp.data.conference_uuid,
          dialerServiceToken: resp.data.token,
          callConfirmationOpen: false,
          isLoading: false,
          startCall: true,
          callModalOpen: true,
        });
      });
  };

  launchConfirmModal = () => {
    const peopleRows = document.querySelectorAll("table.all-people-table input:checked");
    const leadRows = document.querySelectorAll("table.leads-table tr input:checked");
    const rows = peopleRows.length > 0 ? peopleRows : leadRows;
    const ids = [];
    Array.from(rows).forEach((i) => {
      const { personUuid } = i.closest("tr").dataset;
      if (personUuid) ids.push(personUuid);
    });

    this.setState({ selectedLeadUuids: ids }, () => {
      this.setState({ callConfirmationOpen: true });
    });
  };

  render() {
    const { dialerServiceUrl } = this.props;
    const {
      callConfirmationOpen,
      callModalOpen,
      conferenceUuid,
      dialerServiceToken,
      isLoading,
      selectedLeadUuids,
      startCall,
    } = this.state;
    return (
      <div>
        <Button size="medium" onClick={this.launchConfirmModal}>
          Call
        </Button>
        <ConfirmationModal
          show={callConfirmationOpen}
          isLoading={isLoading}
          selectedLeadUuids={selectedLeadUuids}
          createDialerSession={this.createDialerSession}
          closeConfirmationModal={this.closeConfirmationModal}
        />
        <ConferenceModal
          dialerServiceUrl={dialerServiceUrl}
          conferenceUuid={conferenceUuid}
          dialerServiceToken={dialerServiceToken}
          selectedLeadUuids={selectedLeadUuids}
          closeCallModal={this.closeCallModal}
          show={callModalOpen}
          startCall={startCall}
        />
      </div>
    );
  }
}

ConferenceCall.propTypes = {
  dialerServiceUrl: PropTypes.string.isRequired,
};

export default ConferenceCall;
